import React, { memo } from "react";

export const TransitionPage: React.FC = memo(() => {

  return (
    <div>遷移先URLテスト</div>
    );
});

